// vendor
import { Inject, Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MatSnackBar } from '@angular/material/snack-bar';

// local application
import { DialogTypes } from './dialog.type';
import { IJsonResponseModel } from 'app/store/global/json-response.model';
import { snackBarConfig } from 'app/utils/config/snack-bar.config';
import { SnackBarComponent } from 'app/shared/components/snack-bar/snack-bar.component';
import { of } from 'rxjs';

@Injectable()
export class DialogEffects {
  constructor(
    private actions: Actions,
    @Inject(MatSnackBar) private snackBar: MatSnackBar
  ) {}

  // we're setting dispatch to false since our effect is not returning any action
  showErrorNotification$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(DialogTypes.Show_Error_Notification_Dialog),
        switchMap(({ payload: { error } }) => {
          let notification: Pick<
            IJsonResponseModel<[]>,
            'success' | 'message'
          > = error;

          if (
            !Object?.keys(error).includes('message') ||
            typeof error === 'string'
          ) {
            notification = {
              success: false,
              message: 'Something went wrong. Please try again!',
            };
          }

          // for error notification
          return of(
            this.snackBar.openFromComponent(SnackBarComponent, {
              ...snackBarConfig(notification),
              panelClass: 'error-snackbar',
            })
          );
        })
      ),
    { dispatch: false }
  );

  // we're setting dispatch to false since our effect is not returning any action
  showSuccessNotificationDialogAction$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(DialogTypes.Show_Success_Notification_Dialog),
        switchMap(({ payload }) => {
          // for success notification
          return of(
            this.snackBar.openFromComponent(SnackBarComponent, {
              ...snackBarConfig(payload),
              panelClass: 'success-snackbar',
            })
          );
        })
      ),
    { dispatch: false }
  );
}
